export enum SignaturePicturePriorityEnum {
  PERSONAL_PICTURE = "PERSONAL_PICTURE",
  OFFICE_PICTURE = "OFFICE_PICTURE",
  NO_PICTURE = "NO_PICTURE",
  LIBELLE_PICTURE = "LIBELLE_PICTURE",
  MANUSCRIT_PICTURE = "MANUSCRIT_PICTURE",
  SCELLEMENT_PICTURE = "SCELLEMENT_PICTURE",
  GUEST_PICTURE = "GUEST_PICTURE",
}
